/** Apparel letter sizes (kits, gloves, etc.) */
export const APPAREL_SIZE_VALUES = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

export const APPAREL_SIZE_LABELS = {
  XS: 'XS — Extra Small',
  S: 'S — Small',
  M: 'M — Medium',
  L: 'L — Large',
  XL: 'XL — Extra Large',
  XXL: 'XXL — Double Extra Large'
};

/** UK shoe sizes from 3 to 14 including half sizes (common cricket / sports range) */
export function buildUkShoeSizeList() {
  const out = [];
  for (let n = 3; n <= 14; n += 0.5) {
    out.push(Number.isInteger(n) ? String(n) : n.toFixed(1));
  }
  return out;
}

export const UK_SHOE_SIZE_OPTIONS = buildUkShoeSizeList();

export function formatUkShoeLabel(code) {
  return `UK ${code}`;
}

/** Checkout: full standard letter sizes (admin only configures sizes for shoes). */
export function getApparelOptionsForProduct() {
  return APPAREL_SIZE_VALUES.map((v) => ({ value: v, label: APPAREL_SIZE_LABELS[v] || v }));
}

export function getUkShoeOptionsForProduct(product) {
  const allowed = product?.available_uk_shoe_sizes;
  const codes =
    Array.isArray(allowed) && allowed.length > 0
      ? UK_SHOE_SIZE_OPTIONS.filter((c) => allowed.includes(c))
      : UK_SHOE_SIZE_OPTIONS;
  return codes.map((c) => ({ value: formatUkShoeLabel(c), label: formatUkShoeLabel(c) }));
}
